export default class UserController {
    /* @ngInject */
    constructor($filter, ApiUser, $ionicLoading, $ionicPopup, ApiAuthentication) {
        this.ApiUser = ApiUser;
        this.ApiAuthentication = ApiAuthentication;
        this.$ionicLoading = $ionicLoading;
        this.$ionicPopup = $ionicPopup;
        this.translate = $filter('translate');
        this.user = {};
    }

    init() {
        this.$ionicLoading.show({
            template: '<spinner-advinda></spinner-advinda>'
        });
        this.ApiUser.getUser().then((user) => {
            this.user = user;
            this.$ionicLoading.hide();
        }, (error) => {
            this.$ionicLoading.hide();
        });
    }

    resetPassword() {
        this.ApiAuthentication.initiatePasswordReset(this.user.email).then((res) => {
            if (res !== undefined) {
                var alertPopup = this.$ionicPopup.alert({
                    title: this.translate('CHECK_EMAIL'),
                    template: this.translate('RESET_PASSWORD_MSG')
                });
            }
        });
    }
}



/** WEBPACK FOOTER **
 ** ./src/app/components/user/user.controller.js
 **/